<template>
  <div class="container">

    <div class="form">
      <el-form ref="formRef" :inline="true" label-width="90px" :model="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="患者姓名" prop="patientName">
              <el-input v-model="form.patientName" clearable placeholder="请输入患者姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="管理医生" prop="doctorId">
              <el-select v-model="form.doctorId" clearable placeholder="请选择管理医生">
                <el-option v-for="item in manageDoctorsList" :key="item.id" :label="item.docName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="患者分组" prop="patientGroupId">
              <el-select v-model="form.patientGroupId" clearable placeholder="请选择患者分组">
                <el-option v-for="item in patientGroupingList" :key="item.groupId"
                  :label="`${item.leaderName}的${item.name}`" :value="item.groupId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="反馈时间" prop="feedbackTime">
              <el-date-picker v-model="form.feedbackTime" type="daterange" clearable value-format="yyyy-MM-dd"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <div class="buttons">
              <el-button type="primary" @click="query_handler">查询</el-button>
              <el-button @click="reset_handler">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="list">
      <el-table :data="table" style="width: 100%">
        <el-table-column prop="serialNumber" align="center" label="序号">
        </el-table-column>
        <el-table-column prop="createTime" align="center" label="反馈时间">
        </el-table-column>
        <el-table-column prop="patientName" align="center" label="患者姓名">
        </el-table-column>
        <el-table-column prop="status" align="center" label="账号状态">
          <template #default="{ row }">
            <span :style="{ color: statusName(row).color }">{{ statusName(row).value }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" label="手机号">
        </el-table-column>
        <el-table-column prop="doctorName" align="center" label="管理医生">
        </el-table-column>
        <el-table-column prop="groupName" align="center" label="患者分组">
          <template #default="{row}" >
              <span>{{ `${row.doctorName}的${row.groupName}` }}</span>
            </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="content" align="center" label="反馈内容">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.pageNum"
        :page-sizes="[10, 20, 50, 100]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "Feedback",
  components: {},
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 10,
        patientName: "",
        doctorId: "",
        patientGroupId: "",
        feedbackTime: [],
      },
      table: [],
      total: 0,
      manageDoctorsList: [],
      patientGroupingList: [],
    }
  },
  computed: {
    statusName() {
      return (row) => {
        const data = (this.$store.state.accountStatusDict || []).find(item => item.key === row.status);
        if (!data) return {
          value: "",
          color: "",
        };
        return data;
      }
    }
  },
  created() {
    this.getManageDoctorsList();
    this.getPatientGroupingList();
    this.getList();
  },
  mounted() {

  },
  methods: {
    query_handler() {
      this.form.pageNum = 1;
      this.getList();
    },
    reset_handler() {
      this.$refs.formRef.resetFields();
      this.getList();
    },
    async getManageDoctorsList() {
      try {
        const res = await this.$get("gp/getNewDoctorList");
        if (!res) return false;
        const { data } = res;
        this.manageDoctorsList = data;
      } catch (e) {
        console.error(`获取管理医生字典失败`, e);
      }
    },
    async getPatientGroupingList() {
      try {
        const res = await this.$get('group/list', {
          docId: this.$store.state.doctor_id
        });
        if (!res) return false;
        const { data } = res;
        this.patientGroupingList = data;
      } catch (e) {
        console.error(`获取患者分组字典失败`, e);
      }
    },
    async getList() {
      try {
        if (!this.form.feedbackTime) {
          this.form.feedbackTime = [];
        }
        this.form.userId = this.$store.state.user_info?.userId || ''
        const res = await this.$post("feedback/list", this.form);
        if (!res) return false;
        const { data } = res;
        this.total = data.total;
        this.table = data.list;
      } catch (e) {
        console.error(`获取意见反馈接口失败`, e);
      }
    },
    // 添加
    add_handler() {
      this.add_data.show = true;
    },
    // 编辑
    edit_handler() {
      this.add_data.show = true;
    },
    // 确定删除
    confirmEvent(row) {
      console.log(row);
    },
    // 取消删除
    cancelEvent() {

    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.getList(this.form);
    },
    handleCurrentChange(e) {
      this.form.pageNum = e;
      this.getList(this.form);
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;

  .list {
    flex: 1;

    .add-button-class {
      width: 100px;
    }

  }
}

.buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.el-input,
.el-select,
.el-date-editor {
  width: 240px;
}

:deep(.el-range-separator) {
  width: 20px;
}

</style>
<style lang="scss" >
.el-tooltip__popper{
  max-width: 80vw;
}
</style>
